// Mã định danh các action của nhật ký truy cập với chứng từ thì chính là ref_type còn lại là các action định nghĩa dưới đây
export default {
    InsertAccount : 'InsertAccount', // Thêm tài khoản
    UpdateAccount : 'UpdateAccount', // Sửa tài khoản
    DeleteAccount : 'DeleteAccount', // Xóa tài khoản
    DeleteDb : 'DeleteDb', // Xóa database
    RenameDb : 'RenameDb', // Đổi tên database,
    CreateDb : 'CreateDb',
};
